import Component from '../../../../../pages/vpp/features/promotions/index';

export default Component;
